import React from "react";
import Logic from "../Services/logic";
import Loader from "./loader";
// import "table2excel";
// const Table2Excel = (window as any).Table2Excel;
const google = (window as any).google;
class Dashboard extends React.Component {
  controlState: any;
  controlSite: any;
  controlType: any;
  controlApplicant: any;
  logic: any;
  state: any = {
    dashboardCss: {},
    chartCss: {},
    controlCss: {},
    filterVal: "Show Filters",
    showFilters: false,
    isLoading: false,
  };
  constructor(props: any) {
    super(props);
    this.logic = new Logic();
    this.state = {
      filterVal: "Show Filters",
      showFilters: false,
      isLoading: true,
    };
    this.excelBtn = this.excelBtn.bind(this);
    this.showFilters = this.showFilters.bind(this);
  }

  async componentDidMount() {
    google.charts.load("current", {
      packages: ["corechart", "controls"],
    });
    google.charts.setOnLoadCallback(this.logic.firstLoad);
  }

  excelBtn() {
    // try {
    //   const chart = (document as any).getElementById("chart-div").getElementsByTagName("table");
    //   const table2Excel = new Table2Excel({
    //     name: "AVF Dashboard Report",
    //   });
    //   table2Excel.export(chart);
    // } catch (ex) {
    //   console.error(ex);
    // }
  }

  showFilters() {
    if (this.state.filterVal === "Show Filters") {
      this.setState({ filterVal: "Hide Filters", showFilters: true });
    } else {
      this.setState({ filterVal: "Show Filters", showFilters: false });
    }
  }

  render() {
    return (
      <div>
        <header>
          <button className="btn-vv" id="excelBtn" onClick={this.excelBtn}>
            <img
              width="16"
              height="16"
              src="https://autotechfm.visualvault.com/Content/VaultBlue/images/Icons/win8_16x16/redo_dark.png"
              alt="Export"
            />
            <p>Export to Excel</p>
          </button>
          <button className="btn-vv" id="showFilters" onClick={this.showFilters}>
            <img
              width="16"
              height="16"
              src="https://autotechfm.visualvault.com/Content/VaultBlue/images/Icons/win8_16x16/search_dark.png"
              alt="Search"
            />
            <p id="showFiltersText">{this.state.filterVal}</p>
          </button>
        </header>

        <div id="dashboard_div">
          <div
            id="control_state"
            className="control_div"
            style={{ display: this.state.showFilters ? "block" : "none" }}
          ></div>
          <div
            id="control_site"
            className="control_div"
            style={{ display: this.state.showFilters ? "block" : "none" }}
          ></div>
          <div
            id="control_type"
            className="control_div"
            style={{ display: this.state.showFilters ? "block" : "none" }}
          ></div>
          <div
            id="control_applicant"
            className="control_div"
            style={{ display: this.state.showFilters ? "block" : "none" }}
          ></div>
          {this.state.showFilters ? (
            <div>
              <div className="control_div">
                <button
                  type="button"
                  className="btn-vv"
                  id="saveFilters"
                  value="Save Filter Options"
                  onClick={this.logic.saveFilters}
                >
                  <img
                    alt="Save"
                    width="16"
                    height="16"
                    src="https://autotechfm.visualvault.com/Content/VaultBlue/images/Icons/win8_16x16/save_dark.png"
                  />
                  <p>Save Filter Options</p>
                </button>
              </div>
            </div>
          ) : null}
          <div id="chart-div"></div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
